// extracted by mini-css-extract-plugin
export default {"dropdown":"Y3LCriX0xIW21vTscvD7","badge":"vlFPRnA2zsAnjZZ6dpA_","button":"eKHd91TYTHc6irffjwJ6"};